// extracted by mini-css-extract-plugin
export var container = "_tj-0";
export var table = "_tj-2";
export var tableWrapper = "_tj-1";